import { createAsyncApiAction } from '@cbgms/base/redux/create-async-action'
import { HttpMethod } from '../../http-method'
import { APIResponse } from 'helpers'

export const getFeatureFlags = () =>
  createAsyncApiAction<APIResponse<string[]>>('gms', {
    method: HttpMethod.GET,
    url: '/enabled-features'
  })
